// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1DPKv","header":"Messages_header__hCwHZ"};